import { useTranslation } from 'react-i18next';
import { Link, type LinkProps } from 'react-router';

import { clsx } from '~/styles/utils';

import { useStepperContext } from './Stepper.context';
import { activeItemStyle, contentStyle, indicatorStyle, itemStyle, stepStyle, visuallyHiddenStyle } from './Stepper.css';

type Props = LinkProps & {
  step: number;
};

export const StepperItem = ({ children, className, step, to, ...delegated }: Props) => {
  const { currentStep } = useStepperContext();

  const { t } = useTranslation(['common']);

  const isPrevious = step < currentStep;
  const isCurrent = step === currentStep;
  const statusLabel = isCurrent ? undefined : isPrevious ? t('common:status.completed') : t('common:status.upcoming');

  const content = (
    <>
      <p className={contentStyle}>
        <span>{step}</span>

        {statusLabel && <span className={visuallyHiddenStyle}>{statusLabel}: </span>}

        <span>{children}</span>
      </p>

      <div aria-hidden className={indicatorStyle}></div>
    </>
  );

  return (
    <li aria-current={isCurrent ? 'step' : undefined} className={clsx(itemStyle, (isPrevious || isCurrent) && activeItemStyle)}>
      {isPrevious ? (
        <Link {...delegated} className={clsx(stepStyle, className)} to={to}>
          {content}
        </Link>
      ) : (
        <div className={clsx(stepStyle, className)}>{content}</div>
      )}
    </li>
  );
};
